import axios from '@/shared/api'

export const state = {
    vModel: []
}

export const mutations = {

}

export const getters = {
    // Whether the user is currently logged in.
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        //dispatch('validate')
    },
    getGridData({commit},data) {
        console.log(commit)
        return axios.post(data.url,{skip:data.skip,take:data.take,filters:data.filters}).then((response)=>{
            let result = response?.Body || {}
            return result
        })
     },
    update({commit},data){
        console.log('commit',commit)
       return axios.post(data.url,data.payload)
    },
    add({commit},data){
        console.log('commit',commit)
        return axios.post(data.url,data.payload)
    },
    delete({commit},data){
        console.log('commit',commit)
        return axios.get(data.url+'?id='+data.id)
    },
    post({commit},request){
        console.log('commit',commit)
        return axios.post(request.url,request.payload, request.config)
    },
    get({commit},request){
        console.log('commit',commit)
        if (typeof request === 'string') {
            return axios.get(request)
        }
        return axios.get(request.url, request.config)
    }, 
    getById({commit},request){
        console.log('commit',commit)
        return axios.get(request.url,{params:{id:request.id}})
    },
    list({commit},url){
        console.log('commit',commit)
        return axios.get(url)
    }
    // updateInfo({commit},payload){
    //     console.log('payload',payload)
    //     if(payload.id)
    //     {
    //         LanguageService.updateLanguage(payload).then((response)=>
    //         {
    //             console.log('response',response)
    //         })
    //     }
    //     else{
    //         LanguageService.addLanguage(payload).then((response)=>
    //         {
    //             console.log('response',response)
    //         })

    //     }
      
    //     commit('SET_CURRENT_DATA',payload)
    // },
}

// ===
// Private helpers
// ===

